import Model from './Model';

class Rocket extends Model {
  constructor() {
    super('rocket', {
      textures: {
        rocket: ['map'],
      },
      configuration: {},
    });
  }
}

export default new Rocket();
